// extracted by mini-css-extract-plugin
module.exports = {"Cheque":"Cheque_Cheque__PPisP"};